import { differenceInMonths, differenceInYears, parseISO } from 'date-fns';

export const formatTimeInRole = (
  startDate: string | null | undefined
): string => {
  if (!startDate) return '';

  const start = parseISO(startDate);
  const now = new Date();

  const totalMonths = differenceInMonths(now, start);
  const years = differenceInYears(now, start);
  const months = totalMonths - years * 12;

  // Format the output
  const parts: string[] = [];

  if (years > 0) {
    parts.push(`${years} yr`);
  }

  if (months > 0) {
    parts.push(`${months} mo`);
  }

  // If both are 0, show "Less than 1 mo" or similar
  if (parts.length === 0) {
    return 'Less than 1 mo';
  }

  return parts.join(' ');
};
